import request from '@/utils/request'

/**
 * 新增异常评估规则
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionEvaluationruleAdd(data) {
  return request({
    type: 'device',
    url: 'exception/evaluationrule/add',
    method: 'post',
    data
  })
}

/**
 * 删除异常评估规则
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionEvaluationruleDelete(data) {
  return request({
    type: 'device',
    url: 'exception/evaluationrule/delete',
    method: 'post',
    data
  })
}

/**
 * 获取异常评估规则详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionEvaluationruleGet(data) {
  return request({
    type: 'device',
    url: 'exception/evaluationrule/get',
    method: 'post',
    data
  })
}

/**
 * 判断异常评估规则是否存在
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionEvaluationruleIsexistGet(data) {
  return request({
    type: 'device',
    url: 'exception/evaluationrule/isexist/get',
    method: 'post',
    data
  })
}

/**
 * 异常评估规则列表(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionEvaluationrulePageListGet(data) {
  return request({
    type: 'device',
    url: 'exception/evaluationrule/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改异常评估规则
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionEvaluationruleUpdate(data) {
  return request({
    type: 'device',
    url: 'exception/evaluationrule/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ExceptionEvaluationRule.js